
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { CellQrLabelOption } from '../../../backend/backendapi';

type Option = {
  name: string;
  value: CellQrLabelOption | null;
}

@Component
export default class CellQrLabelOptionSelector extends Vue {
  @Prop({ required: true })
  readonly value!: CellQrLabelOption | null;

  get options(): Option[] {
    return [{name: 'none', value: null},
      ...Object.entries(CellQrLabelOption)
          .filter(([key, _]) => !key.match(/^\d+$/))
          .map(([name, value]) => ({ name, value: parseInt(value as string) })),
    ];
  }

  camelCase(s: string): string {
    if (s.length < 1) {
      return s;
    }
    return s[0].toLocaleLowerCase() + s.slice(1);
  }
}
